// extracted by mini-css-extract-plugin
export default {"addToCartControl":"z3-z","giftCard":"A3-z","btnContainer":"B3-z","cartButton":"C3-z","disabled":"D3-z"};